export default class Controller {
    constructor(view) {
        // not much else to do here for now
        // more details will come when validation is added
        this.view = view;
    }

    resetView() {
        this.view.resetView();
    }
}
